// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  PRODUCT_SLIDER: '[data-fragment="TopProductsSlider.slider"]',
};

// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';

export default class TopProductsSlider extends WebComponent {
  didMount() {
    this.swiperElement = this.element.querySelector(fragments.PRODUCT_SLIDER);

    this.swipers = new Swiper(this.swiperElement, {
      modules: [Navigation, Pagination],
      loop: true,
      // If we need pagination
      pagination: {
        el: '.top-products__inner .swiper-pagination',
        clickable: true,
      },
      // Navigation arrows
      navigation: {
        nextEl: '.top-products__inner .swiper-button-next',
        prevEl: '.top-products__inner .swiper-button-prev',
      },
      spaceBetween: 15,
      slidesPerView: 2,
      breakpoints: {
        480: {
          // slidesPerView: 3,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/TopProductsSlider.js